import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Picture } from '@app/entity';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { ImageCropperComponent } from '@app/shared/image-cropper/image-cropper.component';
import { head } from '@app/shared/utils';

const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 mb

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit, OnDestroy {
  @Output() onChange = new EventEmitter<Picture>();
  @Output() onCancel = new EventEmitter();
  @Output() onLoaderChange = new EventEmitter();
  @Input() aspectRatio = 1;
  @Input() message = 'Вы можете загрузить изображение в формате JPG, GIF или PNG.';
  @Input() disableLoad = false;

  isLoading = false;
  isDragging = false;
  progress = 0;
  error: string = null;

  @ViewChild('input')
  private inputElement: ElementRef;

  @ViewChild('cropper')
  private cropper: ImageCropperComponent;

  private uploadSubscription: Subscription;

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.uploadSubscription) this.uploadSubscription.unsubscribe();
  }

  onFileSelected(event: Event) {
    this.error = null;
    this.cropper.loadImage(event);
  }

  onDragOver(event: DragEvent) {
    this.stop(event);
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    this.stop(event);
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    this.stop(event);
    this.isDragging = false;
    this.onFileSelected(event);
  }

  upload(croppedImage: Promise<Blob>) {
    croppedImage.then(d => this.uploadApi(d));
  }

  private uploadApi(file: Blob) {
    this.error = null;
    if (!this.validateSize(file)) return;

    const data = new FormData();
    data.append('image', file, 'image.jpg');

    const loader = this.http.post<Picture>('/picture/', data, {
      reportProgress: true,
      observe: 'events',
    })
      .finally(() => this.isLoading = false);

    this.inputElement.nativeElement.value = '';
    this.cropper.reset();  // here error is shown in place of the cropper, so we should reset it

    if (this.disableLoad) {
      this.onLoaderChange.emit(loader);
      return;
    }

    this.isLoading = true;

    if (this.uploadSubscription) this.uploadSubscription.unsubscribe();

    this.uploadSubscription = loader
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = 100 * event.loaded / event.total;
        } else if (event.type === HttpEventType.Response) {
          this.onChange.next(event.body);
        }
      }, error => {
        const message = 'Не удалось загрузить изображение. Попробуйте еще раз';
        this.error = head(error.error['non_field_errors']) || head(error.error['image']) || error.message || message;
      });
  }

  cancel() {
    this.onCancel.emit();
  }

  stop(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  private validateSize(file: Blob): boolean {
    if (file.size < MAX_FILE_SIZE) return true;
    this.error = `Слишком большой файл. Размер файла не должен превышать ${MAX_FILE_SIZE} Мб`;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/image-upload/image-upload.component.ts